import React, { createContext, useContext } from "react";

import { Control, FieldErrors, UseFormSetValue, UseFormWatch } from "react-hook-form";

import { UserDetailsInput, UserInput } from "../steps/RegisterFormTypes";

export interface RegisterFormContextType {
  control: Control<UserDetailsInput>;
  errors: FieldErrors<UserDetailsInput>;
  multiFormData: UserInput;
  watch: UseFormWatch<UserDetailsInput>;
  setValue: UseFormSetValue<UserDetailsInput>;
  isJoiningExistingAccount: boolean;
  isAmp: boolean;
  isCMO: boolean;
  isArtCentreReporter: boolean;
  isArtCentreRecipient: boolean;
  isArtist: boolean;
  isBeneficiary: boolean;
  isRoyaltyRecipientOnly: boolean;
  isAbnRegistered?: boolean;
  handleCheckboxChange: (checked: boolean) => void;
  handleAbnRegistrationStatus: (checked: boolean) => void;
}

export const RegisterFormContext = createContext<RegisterFormContextType | undefined>(undefined);

export const RegisterFormProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: RegisterFormContextType;
}) => {
  return <RegisterFormContext.Provider value={value}>{children}</RegisterFormContext.Provider>;
};

export const useRegisterFormContext = () => {
  const context = useContext(RegisterFormContext);
  if (!context) {
    throw new Error("useFormContext must be used within a FormProvider");
  }
  return context;
};
